module.exports = __webpack_public_path__ + "img/cc-logo-md.44951bf8.png";